import changePasswordMessages from '../../../../messages/change-password.messages';
import commonErrorMessages from '../../../../messages/common-messages/common-error.messages';
import { ErrorMessages } from '../../../../model/error';
import { isPasswordValid } from '../../../../utils/validators';
import { UserState } from '../../../data/user';
import {
  ChangePasswordError,
  ChangePasswordParams,
} from './change-password-types';

export const verifyChangePasswordFields = (
  formValues: ChangePasswordParams,
  userValues: UserState
): ChangePasswordError | undefined => {
  const { newPassword, newPasswordConfirm, oldPassword } = formValues;
  const username = userValues.username;

  if (!newPassword || !newPasswordConfirm || !oldPassword) {
    return 'FILL_ALL_FIELDS';
  }
  if (newPassword !== newPasswordConfirm) {
    return 'PASSWORDS_NOT_MATCHING';
  }
  if (newPassword === oldPassword) {
    return 'PASSWORD_ALREADY_USED';
  }
  if (!isPasswordValid(newPassword, username)) {
    return 'INVALID_PASSWORD_FORMAT';
  }
  return undefined;
};

export const messagesForChangePasswordError = (
  error: ChangePasswordError
): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
    case 'INVALID_CREDENTIALS':
      return { title: changePasswordMessages.errorTitleInvalidCredentials };
    case 'INVALID_PASSWORD_FORMAT':
      return {
        title: changePasswordMessages.errorTitleInvalidCriteria,
        description: changePasswordMessages.errorDescriptionInvalidCriteria,
      };
    case 'PASSWORDS_NOT_MATCHING':
      return { title: changePasswordMessages.errorTitlePasswordNotMatching };
    case 'PASSWORD_ALREADY_USED':
      return { title: changePasswordMessages.errorTitlePasswordAlreadyUsed };
    case 'FILL_ALL_FIELDS':
      return { title: changePasswordMessages.errorTitleFillInAllFields };
    case 'PASSWORD_VECCHIA_NON_VALIDA':
      return { title: changePasswordMessages.oldPasswordWrong };
  }
};
